import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-linear-gauge',
  templateUrl: './linear-gauge.component.html',
  styleUrls: ['./linear-gauge.component.scss']
})
export class LinearGaugeComponent implements OnChanges {
  chartOption: any;

  @Input() linearGaugeData: any;

  constructor() { }

  ngOnChanges(): void {
    if (this.linearGaugeData) {
      this.plotLinearGuage();
    }
  }

  /**
   * Plots grouped bar
   */
  plotLinearGuage() {
    const pathSymbols = {
      marker: 'path://m199.565757,136.944121l21.902885,0l0,34.282792l-10.95145,8.570707l-10.951448,-8.570707l0.000012,-34.282792z'
    };
    const labels = [];
    const colorRange = {
      '0 - 25': ['#FF0C0C', '#FF3F00', '#FF7A00', '#FFA100'],
      '25 - 50': ['#FFA100', '#FFCF00', '#FFED00', '#FFF800'],
      '50 - 62': ['#FFF800', '#C7E300', '#88C400', '#5DAE00'],
      '62 - 75': ['#5DAE00', '#0D8700'],
      '62 - 100': ['#0D8700']
    };
    for (let i = 0; i <= 100; i += 10) {
      labels.push(`${i}%`);
    }
    this.chartOption = {
      yAxis: {
        show: false,
        boundaryGap: false,
        data: ['']
      },
      xAxis: [
        {
          type: 'value',
          show: false, // Hide the value axis
          min: 0,
          max: 100
        },
        {
          type: 'category',
          position: 'bottom',
          boundaryGap: false,
          axisTick: {
            show: false, // Ensure axis ticks are disabled
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#333', // Color of the axis line
              width: 1, // Width of the axis line
              type: 'solid' // Type of line
            }
          },
          data: labels, // Specify the desired labels
          axisLabel: {
            show:false
            // interval: 0, // Display all labels,
            // formatter: function (value) {
            //   if (value === '0%' ||value === '100%') {
            //     return `{tick|}\n{value|${value}}`;
            //   } else {
            //     return null;
            //   }
            // },
            // rich: {
            //   value: {
            //     lineHeight: 25, // Adjust the line height to align ticks and labels
            //   },
            //   // tick: {
            //   //   height: 10, // Adjust the height of ticks
            //   //   width: 1, // Adjust the width of ticks
            //   //   backgroundColor: '#333', // Color of ticks
            //   // }
            // }
          }
        }
      ],
      series: [
        {
          type: 'scatter',
          symbol: pathSymbols.marker,
          silent: false,
          label: {
            show: false,
            formatter: '{c}%', // Display the value of the scatter point
            position: 'top' // Position the label above the scatter symbol
          },
          itemStyle: {
            color: function (param) {
              const data = param.data;
              for (const [range, colors] of Object.entries(colorRange)) {
                const [start, end] = range.split(' - ').map(Number);
                if (data === 100) {
                  return '#0D8700';
                } else if (data >= start && data < end) {
                  const segmentWidth = (end - start) / colors.length;
                  const colorIndex = Math.floor((data - start) / segmentWidth);
                  return colors[colorIndex];
                }
              }
              return 'rgba(0,0,0,0.3)'; // Default color if no range matches
            },
            borderColor: '#000',
            borderWidth: 1,

          },
          symbolSize: [10, 20],
          // symbolRotate: 90,
          symbolOffset: ['0%', '0%', '25%'],
          z: 20,
          data: [Math.trunc(this.linearGaugeData?.status * 10) / 10], //RUL Percentage from API
          emphasis: {
            label: {
              show: false,
              formatter: function (param) {
                return param.data + ' %';
              },
              position: 'top'
            }
          },
        },
        {
          type: 'bar',
          silent: true,
          animation: false,
          barWidth: 10,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 1, y2: 0,
              colorStops: [
                { offset: 0, color: 'red' },       // Start color of the first bar
                { offset: 1, color: 'red' }     // End color of the first bar and start color of the second bar
              ]
            },
            borderRadius: [10, 0, 0, 10] // Rounded corners for the first bar
          },
          stack: 'total',
          data: [25]
        },
        {
          type: 'bar',
          silent: true,
          animation: false,
          barWidth: 10,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 1, y2: 0,
              colorStops: [
                { offset: 0, color: 'red' },    // Start color of the second bar
                { offset: 1, color: 'red' }     // End color of the second bar and start color of the third bar
              ]
            },
            borderRadius: [0, 0, 0, 0] //No Rounded corners for the second bar
          },
          stack: 'total',
          data: [25]
        },
        {
          type: 'bar',
          silent: true,
          animation: false,
          barWidth: 10,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 1, y2: 0,
              colorStops: [
                { offset: 0, color: 'green' },    // Start color of the third bar
                { offset: 1, color: 'green' }      // End color of the third bar and start color of the fourth bar
              ]
            },
            borderRadius: [0, 0, 0, 0] // No Rounded corners for the third bar
          },
          stack: 'total',
          data: [25]
        },
        {
          type: 'bar',
          silent: true,
          animation: false,
          barWidth: 10,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 1, y2: 0,
              colorStops: [
                { offset: 0, color: 'green' },     // Start color of the fourth bar
                { offset: 1, color: 'green' }      // End color of the fourth bar
              ]
            },
            borderRadius: [0, 10, 10, 0] // Rounded corners for the fourth bar
          },
          stack: 'total',
          data: [25]
        }
      ]
    }
  }
}
